import React, { Fragment, useEffect, useRef, useState } from "react";
import "./style.scss";
import { useTable } from "react-table";
import download from "../../../assets/icons/download.svg";
import { useDispatch, useSelector } from "react-redux";
import { deleteCoupon } from "../../../store/reducers/couponSlice";
import { ReactComponent as CopyIcon } from "../../../assets/icons/CopyIcon.svg";
import { ReactComponent as BrandCopyIcon } from "../../../assets/icons/BrandCopyIcon.svg";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import {
  amendPayoutRequest,
  generatePayoutRequest,
  generatePayoutRequestNew,
  getCommission,
  getPayoutListRequest,
  UserSearchReq,
} from "../../../utils/api/apis";
import { returnErrors } from "../../../store/reducers/error";
import { setIsLoading } from "../../../store/reducers/authSlice";
import moment from "moment";
import Select from "react-select";
import Modal from "@mui/material/Modal";
import { ReactComponent as SearchNew } from "../../../assets/icons/search-svgrepo-com (1).svg";

import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Pagination,
  Tooltip,
} from "@mui/material";
import { returnMessages } from "../../../store/reducers/message";
import ConfirmationModal from "../../../pages/FundingEvaluation/ConfirmationModal";
import "./style.scss";
import { toast } from "react-toastify";
import CopyToClipboard from "react-copy-to-clipboard";
import TextField from "@mui/material/TextField";
import { Link } from "react-router-dom";
import {
  setActiveAccount,
  setActiveEmail,
  setActiveUser,
} from "../../../store/reducers/accountSlice";
import { formatCurrency } from "../../../utils/helpers/string";

import { HtmlTooltip } from "../../../reusableComponents/Tooltip";
import ReactCountryFlag from "react-country-flag";
import { country } from "../../../utils/constants/country";

function Withdraw() {
  const handleNavigateToOverView = async (value) => {
    // dispatch(setIsLoading(true));
  };

  const [searchedUser, setSearchUser] = useState([]);
  const [activeTab, setactiveTab] = useState();
  const [payoutType, setPayoutType] = useState(null);
  const [searchDropDown, setSearchDropDown] = useState(false);
  const [search, setSearch] = useState(null);
  const [commissionId, setCommissionId] = useState([]);
  const [commissionAmount, setCommissionAmount] = useState("");
  const dropdownRef = useRef(null);
  const [currentPage, setCurrentPage] = useState(1);

  // const methods = [
  //   { label: "All", value: null },
  //   { label: "DEEL", value: "DEEL" },
  //   { label: "ACH", value: "ACH" },
  //   { label: "WIRE", value: "WIRE" },
  //   { label: "SWIFT", value: "SWIFT" },
  //   { label: "PAYPAL", value: "PAYPAL" },
  // ];
  const methods = [
    { label: "All", value: null },
    { label: "New", value: "New" },
    { label: "Approved", value: "Approved" },
    { label: "Rejected", value: "rejected" },
    { label: "Pending", value: "pending" },
  ];

  const [method, setMethod] = useState(methods[0]);
  const [duplicateWallets, setDuplicateWallets] = useState(null);
  const [status, setStatus] = useState(null);
  const [searchValue, setSearchValue] = useState("");

  let timeoutId;

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    if (value.trim().length === 0) {
      setSearch(null);
      setCurrentPage(1);
    }
  };
  const inputRef = useRef(null);
  const handleResetClick = () => {
    if (inputRef.current) {
      inputRef.current.value = "";
      setSearch(null);
    }
  };

  const [selectedEmail, setSelectedEmail] = useState();

  const [isDeleteConfirmationModalOpen, setDeleteConfirmationModalOpen] =
    useState(false);
  const [deleteConfirmationModalContent, setDeleteConfirmationModalContent] =
    useState(null);
  const [selectedRow, setSelectedRow] = useState(null);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };

  const [payout, setPayout] = useState({
    amount: commissionAmount || 0,
    payout_type: "PFS",
    method: "",
    commission: commissionId || [],
    crypto_type: "",
    email: selectedEmail,
  });

  useEffect(() => {
    setPayout((prev) => ({
      ...prev,
      commission: commissionId || [],
      amount: Math.round(commissionAmount) || 0,
      ...(prev.payout_type === "AFS" && { email: selectedEmail }), // Conditionally include email as a key
    }));
  }, [commissionId, commissionAmount]);

  const payoutTypes = [
    {
      label: "Funding Account",
      value: "PFS",
    },
    {
      label: "Affiliate Payout",
      value: "AFS",
    },
  ];
  const paymentMethods = [
    { label: "SWIFT", value: "SWIFT" },
    // { label: "PAYPAL", value: "PAYPAL" },
    { label: "USDT BEP-20", value: "CRYPTO_BEP", crypto_type: "USDT BEP-20" },
    { label: "USDT ERC-20", value: "CRYPTO_ERC", crypto_type: "USDT ERC-20" },
  ];

  useEffect(() => {
    if (
      payout?.crypto_type === "USDT BEP-20" ||
      payout?.crypto_type === "USDT ERC-20"
    ) {
      setPayout((prev) => ({
        ...prev,
        method: "CRYPTO",
      }));
    }
  }, [payout?.crypto_type]);

  const [openModal, setOpenModal] = React.useState(false);
  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();

  const handlePayoutReq = async () => {
    if (!payout?.method || payout?.method === null) {
      dispatch(returnErrors("Please Select Payout Method", 400));
      return;
    }

    if (payout.payout_type === "AFS") {
      if (!selectedEmail) {
        dispatch(returnErrors("Email is required", 400));
        return;
      }
    }

    if (payout.payout_type === "PFS") {
      if (!payout?.login_id) {
        dispatch(returnErrors("Login id is required", 400));
        return;
      }
    }

    const response = await generatePayoutRequestNew(idToken, payout);
    console.log(response, "success message");
    if (response.status < 399) {
      dispatch(returnMessages("Successfully generate payout request", 500));
      handleCloseModal();
    } else {
      const error = response.response.data;
      let msg;
      if (Object.keys(error).length > 0) {
        const firstKey = Object.keys(error)[0];
        const firstString = error[firstKey] || error[firstKey][0];

        msg = firstString;
      } else {
        msg = "Something went wrong";
      }
      dispatch(returnErrors(msg, 500));
    }
  };

  // Fetch Email

  const [isLoading, setIsLoading] = useState(false);
  const [emailOpts, setEmailOpts] = useState([]);
  const [data, setData] = useState({});

  const fetch = async (value) => {
    setIsLoading(true);
    const response = await UserSearchReq(idToken, value);
    setIsLoading(false);
    if (response?.status < 399) {
      let userArray = [];
      response.data.map((item) =>
        userArray.push({
          label: item?.email,
          value: item?.id,
        })
      );
      // //removed clg
      setEmailOpts(userArray);
    } else {
      // //removed clg
      if (response.response.data.message) {
        return;
      }
      let msg = response?.response?.data?.detail || "Something went wrong";
      dispatch(returnErrors(msg, 400));
    }
  };

  const customStyles = {
    control: (provided) => ({
      ...provided,
      background: "none",
      width: "100%",
      marginTop: "0px",
      height: 60,
      borderRadius: 8,
      border: "1px solid #eaf0f8;",
      boxShadow: "none",
      fontFamily: "DM Sans, sans-serif",
      fontSize: "14px",
      fontWeight: 700,
      minHeight: "48px",
      height: "48px",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "grey",
      fontSize: "14px",
      fontWeight: 500,
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      height: "48px",
      padding: "0 6px",
      fontWeight: 500,
      marginLeft: "10px",
      color: "#000",
    }),
    singleValue: (provided, state) => ({
      ...provided,
      color: "var(--text-color)",
    }),
    input: (provided, state) => ({
      ...provided,
      margin: "0px",
      color: "#000",
    }),
    indicatorSeparator: (state) => ({
      display: "none",
    }),
    indicatorsContainer: (provided, state) => ({
      ...provided,
      height: "48px",
    }),
  };

  // let timeoutId = "";
  const handleOninputChange = (value) => {
    if (typeof value === "string" && value.length > 0) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        fetch(value);
      }, 3000);
    }
  };

  const handleEmailSelect = (selectedOption) => {
    if (selectedOption) {
      setSelectedEmail(selectedOption.label);
    }
  };

  const handleCommission = async () => {
    const res = await getCommission(idToken, selectedEmail);

    console.log("res", res);

    if (res.status === 200) {
      const commissionData = res?.data && res?.data?.map((item) => item);
      const commissionDataId = res?.data && res?.data?.map((item) => item?.id);

      const totalAmount = commissionData.reduce(
        (total, item) => total + (item.amount || 0),
        0
      );
      setCommissionId(commissionDataId);
      setCommissionAmount(totalAmount);
    } else {
      dispatch(
        returnErrors(
          res?.response?.data?.details ||
            "Failed to fetch commission data. Please try again.",
          400
        )
      );
    }
  };
  const { selectedBrand } = useSelector((state) => state.brand);
  useEffect(() => {
    if (selectedEmail) {
      handleCommission();
    }
  }, [selectedEmail]);
  const [planType, setPlanType] = useState(null);

  const plantypesOptions = [
    {
      label: "All",
      value: null,
    },
    {
      label: "1 Step",
      value: "1_step",
    },
    {
      label: "2 Step",
      value: "2_step",
    },
    ...(selectedBrand?.brand === "equity_edge"
      ? [
          {
            label: "Instant",
            value: "pro_edge",
          },
        ]
      : [
          {
            label: "Instant Funding",
            value: "instant_funding",
          },
        ]),
  ];

  const [payoutTypeValue, setPayoutTypeValue] = useState(null);

  const payoutTypeOption = [
    {
      label: "All Payout Type",
      value: null,
    },
    {
      label: "AFS",
      value: "AFS",
    },
    {
      label: "PFS",
      value: "PFS",
    },
  ];

  return (
    <div className="table_scroll_wrapper">
      <div className="withdraw_table alltable">
        <div className="alltable_header">
          <form
            className="search_container"
            onSubmit={(e) => {
              e.preventDefault();
              const trimmed = (searchValue || "").trim();
              setSearch(trimmed.length ? trimmed : null);
              setCurrentPage(1);
            }}
          >
            <input
              type="text"
              placeholder="Search..."
              onChange={handleSearchChange}
            />
            <button type="submit">
              <div style={{ padding: "3px 10px 0 0" }}>
                <SearchNew style={{ width: "100%" }} />
              </div>
            </button>
          </form>
          <div
            className="sort_buttons"
            style={{ height: "60px", display: "flex", alignItems: "center" }}
          >
            {/* <Select
              placeholder="Status"
              classNamePrefix="react-select"
              options={methods}
              value={method}
              onChange={(selectedOption) => {
                selectedOption.value === null
                  ? setMethod(null)
                  : setMethod(selectedOption);
              }}
            /> */}
            <div
              style={{
                flex: "1",
                display: "flex",
                gap: "10px",
                flexWrap: "wrap",
              }}
            >
              {methods.map((item) => (
                <button
                  onClick={() =>
                    setMethod({ lable: item.label, value: item.value })
                  }
                  className={method?.value === item?.value ? "activeBtn" : ""}
                >
                  {item.label}
                </button>
              ))}
              <button
                onClick={() => setDuplicateWallets((pre) => !pre)}
                className={duplicateWallets === true ? "activeBtn" : ""}
                style={{ textWrap: "nowrap" }}
              >
                Duplicate Wallets
              </button>
              <div className="input_form-mid">
                <div className="input_wrapper">
                  <Select
                    options={plantypesOptions}
                    value={plantypesOptions.find(
                      (item) => item.value === planType
                    )}
                    onChange={(options) => setPlanType(options.value)}
                  />
                </div>
              </div>
              <div className="input_form-mid">
                <div className="input_wrapper">
                  <Select
                    options={payoutTypeOption}
                    value={payoutTypeOption.find(
                      (item) => item.value === payoutTypeValue
                    )}
                    onChange={(options) => {
                      setPayoutTypeValue(options.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
              <button
                onClick={() => handleOpenModal()}
                // className={method?.value === item?.value ? "activeBtn" : ""}
                style={{
                  border: "1px solid black",
                  color: "black",
                  display: "flex",
                  alignItems: "center",
                  padding: "10px !important",
                  gap: "20px",
                }}
              >
                <span style={{ textWrap: "nowrap" }}>Generate Payout</span>{" "}
                <span style={{ transform: "scale(2)" }}>+</span>
              </button>
            </div>
          </div>
        </div>
        {searchDropDown && (
          <div className="challenge_dropdown" ref={dropdownRef}>
            <ul>
              {searchedUser.map((user) => (
                <li
                  key={user.email}
                  style={{
                    position: "relative",
                    zIndex: "100",
                    backgroundColor: "#111142",
                  }}
                  onClick={() => {
                    handleNavigateToOverView(user.email);
                  }}
                >
                  {user.email}
                </li>
              ))}
            </ul>
          </div>
        )}
        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="payoutModal">
            <Select
              placeholder="Payout type"
              classNamePrefix="react-select"
              options={payoutTypes}
              // value={method}
              onChange={(selectedOption) => {
                setPayout((pre) => ({
                  ...pre,
                  payout_type: selectedOption.value,
                }));
              }}
            />
            <Select
              placeholder="Payout method"
              classNamePrefix="react-select"
              options={paymentMethods}
              // value={method}
              onChange={(selectedOption) => {
                setPayout((pre) => ({
                  ...pre,
                  method: selectedOption.value,
                  crypto_type: selectedOption.crypto_type,
                }));
              }}
            />

            {payout?.payout_type === "PFS" ? (
              <Select
                isLoading={isLoading}
                placeholder={"Search for a user"}
                styles={customStyles}
                options={emailOpts}
                onInputChange={(value) => handleOninputChange(value)}
                onChange={(selectedOption) => {
                  setData((prev) => ({ ...prev, user: selectedOption.value }));
                  setPayout({ ...payout, email: selectedOption?.label });
                  handleEmailSelect(selectedOption); // Call the handleEmailSelect function separately
                }}
                // onChange={(selectedOption) => setData((prev) => ({...prev, user: selectedOption.value}, handleEmailSelect(selectedOption.label)))}
              />
            ) : (
              <></>
            )}

            {payout.payout_type === "AFS" ? (
              <Select
                isLoading={isLoading}
                placeholder={"Search for a user"}
                styles={customStyles}
                options={emailOpts}
                onInputChange={(value) => handleOninputChange(value)}
                onChange={(selectedOption) => {
                  setData((prev) => ({ ...prev, user: selectedOption.value }));
                  setPayout({ ...payout, email: selectedOption?.label });
                  handleEmailSelect(selectedOption); // Call the handleEmailSelect function separately
                }}
                // onChange={(selectedOption) => setData((prev) => ({...prev, user: selectedOption.value}, handleEmailSelect(selectedOption.label)))}
              />
            ) : (
              <TextField
                placeholder="Login Id"
                id="outlined-basic"
                variant="outlined"
                // type="number"
                size="small"
                onChange={(e) => {
                  const value = e.target.value;
                  setPayout((pre) => ({
                    ...pre,
                    login_id: value,
                  }));
                }}
              />
            )}
            <TextField
              placeholder="Amount"
              id="outlined-basic"
              variant="outlined"
              size="small"
              type="number"
              value={payout.payout_type === "AFS" ? commissionAmount : null}
              onChange={(e) => {
                setPayout((pre) => ({
                  ...pre,
                  amount: e.target.value,
                }));
              }}
            />
            <button
              onClick={() => handlePayoutReq()}
              style={{
                backgroundColor: "var(--secondary-color)",
                border: "1px solid var(--secondary-color)",
                color: "white",
                borderRadius: "10px",
                padding: "10px",
                flex: "1 1",
                margin: "0px",
              }}
            >
              Generate Payout
            </button>
          </div>
        </Modal>

        <div className="table_wrapper">
          <div className="table_scroll_wrapper">
            <Table
              search={search}
              payoutType={payoutType}
              method={method?.value}
              setSelectedRow={setSelectedRow}
              selectedRow={selectedRow}
              setDeleteConfirmationModalOpen={setDeleteConfirmationModalOpen}
              setDeleteConfirmationModalContent={
                setDeleteConfirmationModalContent
              }
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              duplicateWallets={duplicateWallets}
              planType={planType}
              payoutTypeValue={payoutTypeValue}
            />
          </div>
        </div>
      </div>

      {isDeleteConfirmationModalOpen && (
        <DeleteModal
          isModalOpen={isDeleteConfirmationModalOpen}
          closeModal={() => setDeleteConfirmationModalOpen(false)}
          deleteContent={deleteConfirmationModalContent}
        />
      )}
    </div>
  );
}

export default Withdraw;

const Table = ({
  search,
  method,
  payoutType,
  setSelectedRow,
  selectedRow,
  handleAddClick,
  currentPage,
  setCurrentPage,
  duplicateWallets,
  planType,
  payoutTypeValue,
}) => {
  const [filter, setFilter] = useState(null);
  const [isCalender, setIsCalender] = useState(false);
  const [date, setDate] = useState(new Date());
  const idToken = useSelector((state) => state.auth.idToken);
  const dispatch = useDispatch();
  // const coupon = useSelector((state) => state.coupon.coupon);
  const [tableData, setTableData] = useState([]);

  const [totalPages, setTotalPages] = useState(1);
  const [pageNumbers, setPageNumbers] = useState([]);

  console.log("payoutType", payoutType);

  useEffect(() => {
    setCurrentPage(method?.length > 0 ? 1 : currentPage);
  }, [method]);
  const { selectedBrand } = useSelector((state) => state.brand);

  const fetch = async () => {
    dispatch(setIsLoading(true));
    // return
    const response = await getPayoutListRequest(
      idToken,
      search,
      method,
      payoutType,
      currentPage,
      duplicateWallets,
      planType,
      selectedBrand,
      payoutTypeValue
    );

    if (response?.status < 399) {
      setTableData(response?.data?.results);
      const test = Math.ceil(response?.data?.count / 20);
      setTotalPages(Math.ceil(response?.data?.count / 20));
    } else {
      dispatch(returnErrors("Error getting Payout list"));
    }
    dispatch(setIsLoading(false));
  };
  useEffect(() => {
    fetch();
  }, [
    idToken,
    filter,
    search,
    method,
    payoutType,
    currentPage,
    duplicateWallets,
    planType,
    payoutTypeValue,
  ]);

  // const data = tableData;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const [code, setCode] = useState();

  const handleDelete = (couponCode) => {
    setCode(couponCode);
  };

  const handleFilter = (status) => {
    setFilter(status);
  };

  const filteredData =
    filter === "All"
      ? tableData
      : filter === true
      ? tableData.filter((item) => item.is_active === true)
      : tableData.filter((item) => item.is_active === false);
  const handleCopyToClipboard = (text) => {
    toast(`Copied ${text}`, {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      type: "success",
      theme: "dark",
      className: "custom-toast-container",
    });
  };
  const statusClassMap = {
    new: "Pending_tag",
    succeeded: "Active_tag",
    rejected: "Inactive_tag",
    approved: "Active_tag",
  };

  const customCountryMap = {
    "united kingdom": "GB", // United Kingdom -> GB
    "united states": "US", // United States -> US
    "south korea": "KR", // South Korea -> KR
    "north korea": "KP", // North Korea -> KP
    "ivory coast": "CI", // Côte d'Ivoire -> CI
    "czech republic": "CZ", // Czech Republic -> CZ (Now Czechia)
    "viet nam": "VN", // Vietnam -> VN
    bolivia: "BO", // Bolivia (shortened)
    venezuela: "VE", // Venezuela -> VE
    "hong kong": "HK", // Hong Kong (SAR China)
    macau: "MO", // Macau (SAR China)
    palestine: "PS", // Palestine -> PS
    russia: "RU", // Russia -> RU (instead of Russian Federation)
    laos: "LA", // Laos -> LA
    españa: "ES",
  };
  const ActionCell = ({ row }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [confirmationModal, setConfirmationModal] = useState(false);
    const [amendModal, setAmendModal] = useState(false);
    const [data, setData] = useState(null);
    const [amount, setAmount] = useState(null);

    const dispatch = useDispatch();
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleStatus = async (e, status) => {
      setConfirmationModal(true);

      // Base user details
      const userDetails = {
        status: status,
        platform: e?.trading_platform || null,
        user_email: e?.email,
      };

      // Append AFS-specific fields if payout_type is AFS
      if (e?.payout_type === "AFS") {
        Object.assign(userDetails, {
          payout_type: "AFS",
          amount_requested: e?.amount_requested || 0,
          method: e?.method || "CRYPTO",
          commission: e?.commission ? e.commission : [],
        });
      }

      setData({ data: userDetails, id: e.id });
    };

    const handleAction = async (e) => {
      const response = await generatePayoutRequest(idToken, data);
      if (response?.status < 399) {
        let msg = response?.data?.detail || "Successful";
        dispatch(returnMessages(msg, response?.status));
        fetch();
      } else {
        let msg = response?.response?.data?.detail || "Something went wrong";
        dispatch(returnErrors(msg, 400));
      }
    };

    const handleAmend = () => {
      setAmendModal(true);
    };

    const handleAmendRequest = async () => {
      try {
        const response = await amendPayoutRequest(
          idToken,
          row.original.id,
          amount || 0
        );
        if (response?.status < 399) {
          dispatch(
            returnMessages(
              response?.data?.detail ||
                "The amount has been successfully amended.",
              200
            )
          );
          fetch();
        } else {
          dispatch(returnErrors(response?.response?.data?.error, 400));
        }
        console.log(response, "khasjrfhgdaujrewhawr");
      } catch (error) {
        console.error("Amend Request Failed", error);
      }
    };

    return (
      <div onClick={(e) => e.stopPropagation()}>
        {confirmationModal && (
          <ConfirmationModal
            setConfirmationModal={setConfirmationModal}
            onConfirm={handleAction}
          />
        )}
        {amendModal && (
          <ConfirmationModal
            id={row.original.id}
            setConfirmationModal={setAmendModal}
            onConfirm={handleAmendRequest}
            showInput
            inputValue={amount}
            setInputValue={setAmount}
          />
        )}

        <Box
          sx={{ display: "flex", alignItems: "center", textAlign: "center" }}
        >
          <Tooltip title="Account settings">
            <IconButton
              onClick={handleClick}
              size="small"
              sx={{ ml: 2 }}
              aria-controls={open ? "account-menu" : undefined}
              aria-haspopup="true"
              aria-expanded={open ? "true" : undefined}
            >
              <MoreVertIcon />
            </IconButton>
          </Tooltip>
        </Box>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          onClick={(e) => e.stopPropagation()}
          PaperProps={{
            elevation: 0,
            sx: {
              minWidth: "150px",
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              mt: 1.5,
              "& .MuiAvatar-root": { width: 32, height: 32, ml: -0.5, mr: 1 },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          {row.original.status === "approved" ||
          row.original.status === "rejected" ? (
            <>
              <MenuItem>{"No Options"}</MenuItem>
            </>
          ) : (
            <>
              {" "}
              <MenuItem onClick={() => handleStatus(row.original, "approved")}>
                {"Approve Payout"}
              </MenuItem>
              <MenuItem onClick={() => handleStatus(row.original, "rejected")}>
                {"Reject Payout"}
              </MenuItem>
            </>
          )}
          {row.original.status === "new" && (
            <MenuItem onClick={handleAmend}>Amend Amount</MenuItem>
          )}
        </Menu>
      </div>
    );
  };

  const columns = React.useMemo(
    () => [
      // {
      //   Header: "UID",
      //   accessor: "uid",
      //   Cell: ({ value }) => (
      //     <td
      //       style={{ maxWidth: "240px", overflow: "hidden" }}
      //       className="code"
      //     >
      //       {value}
      //     </td>
      //   ),
      // },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ row }) => <ActionCell row={row} />,
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value }) => (
          <span className={`status_wrapper ${statusClassMap[value]}`}>
            {value.toUpperCase()}
          </span>
        ),
      },
      {
        Header: "Email",
        accessor: "email",
        Cell: ({ value }) => {
          const [randomColor, setRandomColor] = useState();
          const getRandomColor = `#${Math.floor(
            Math.random() * 16777215
          ).toString(16)}`;
          if (!randomColor) {
            setRandomColor(getRandomColor);
          }
          const handleCopyToClipboard = (text) => {
            toast("Copied email", {
              position: "top-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              type: "success",
              theme: "dark",
              className: "custom-toast-container",
            });
          };

          return (
            <>
              <div className="column_one_wrapper">
                {/* <div
                  className="sno_wrapper"
                  style={{ backgroundColor: randomColor }}
                >
                  {value.charAt(0).toUpperCase()}
                </div> */}
                <div>{value}</div>
                <CopyToClipboard onCopy={handleCopyToClipboard} text={value}>
                  {/* <button> */}
                  <p
                    className="table_copy_button"
                    style={{
                      marginRight: "20px",
                      cursor: "pointer",
                    }}
                  >
                    {selectedBrand?.brand === "crypto_edge" ? (
                      <BrandCopyIcon />
                    ) : (
                      <CopyIcon />
                    )}
                  </p>
                  {/* </button> */}
                </CopyToClipboard>
              </div>
            </>
          );
        },
      },
      {
        Header: "Login ID",
        accessor: "login_id",
        Cell: ({ row }) => {
          const handleActiveAccount = (row) => {
            row.original?.login_id
              ? dispatch(setActiveAccount(row.original))
              : dispatch(setActiveAccount(null));
            dispatch(setActiveUser({ ...row.original }));
          };
          return (
            <Link
              onClick={(e) => {
                e.stopPropagation();
                handleActiveAccount(row);
              }}
              to="/traders-list-2"
            >
              {row.original.login_id}
            </Link>
          );
        },
      },
      {
        Header: "Account Size",
        accessor: "account_size",
        Cell: ({ value }) => Number(value).toLocaleString(),
      },

      {
        Header: "Date Created",
        accessor: "created_at",
        Cell: ({ value }) => (
          <span style={{ paddingRight: "20px" }}>
            {moment.utc(value).format("ll")}
          </span>
        ),
      },
      // {
      //   Header: "Net Amount",
      //   accessor: "net_amount",
      //   Cell: ({ value }) => <div>{formatCurrency(value || 0)}</div>,
      // },
      {
        Header: "Amount Requested",
        accessor: "amount_requested",
        Cell: ({ value }) => <div>{formatCurrency(value || 0)}</div>,
      },
      {
        Header: "Amended Amount",
        accessor: "amended_amount",
        Cell: ({ value }) => <div>{formatCurrency(value || "-")}</div>,
      },
      {
        Header: "Deduction",
        accessor: "amount_difference",
        Cell: ({ value }) => <div>{formatCurrency(value || "-")}</div>,
      },

      { Header: "Method", accessor: "method" },
      {
        Header: "Plan",
        accessor: "plan",
        Cell: ({ value }) => <div>{value?.replace("_", " ") || "N/A"}</div>,
      },

      {
        Header: "Country Name",
        accessor: "",
        Cell: ({ row }) => (
          <span style={{ paddingRight: "20px" }}>
            {row?.original?.country ? row?.original?.country : "N/A"}
          </span>
        ),
      },
      {
        Header: "Country",
        accessor: "country",
        Cell: ({ row, value }) => {
          const findCountry = (value) => {
            return (
              country.find((c) => c.country === value) || // Search by country name
              country.find((c) => c.iso === value) // Search by ISO code
            );
          };

          const selectedCountry = findCountry(value);

          return (
            <div style={{ cursor: "pointer" }}>
              {selectedCountry ? (
                <HtmlTooltip
                  title={selectedCountry?.country}
                  placement="right"
                  followCursor={true}
                  slotProps={{
                    popper: {
                      modifiers: [
                        {
                          name: "offset",
                          options: {
                            offset: [0, 20],
                          },
                        },
                      ],
                    },
                  }}
                  arrow
                >
                  <div>
                    <ReactCountryFlag
                      countryCode={selectedCountry?.iso}
                      svg
                      style={{
                        width: "2em",
                        height: "2em",
                      }}
                      // title={value}
                      title={selectedCountry?.country || "N/A"}
                      aria-label={selectedCountry?.country || "N/A"}
                    />
                    {/* <p>{value}</p> */}
                  </div>
                </HtmlTooltip>
              ) : (
                "N/A"
              )}
            </div>
          );
        },
      },
      // { Header: "Payout type", accessor: "payout_type" },

      {
        Header: "Profit Split",
        accessor: "profit_split",
        Cell: ({ value }) => <div>{value || "-"}</div>,
      },
      { Header: "Payout Type", accessor: "payout_type" },
      {
        Header: "Platform",
        accessor: "trading_platform",
        Cell: ({ row, value }) => (
          <p style={{ textTransform: "capitalize" }}>{value ? value : "-"}</p>
        ),
      },
      {
        Header: "Issue Type",
        accessor: "issue_type",
        Cell: ({ row, value }) => (
          <p style={{ textTransform: "capitalize" }}>{value ? value : "-"}</p>
        ),
      },
      {
        Header: "Browser Id",
        accessor: "browser_id",
        Cell: ({ row, value }) => (
          <p>
            {row?.original?.meta?.browser_id
              ? row?.original?.meta?.browser_id
              : "-"}
          </p>
        ),
      },

      // { Header: "User", accessor: "user" },

      // mahendra code

      // {
      //   Header: "Invoice",
      //   accessor: "invoice",
      //   Cell: ({ value }) => (
      //     <>
      //       {value ? (
      //         <a target="_blank" href={value}>
      //           <img src={download} alt="" />
      //         </a>
      //       ) : (
      //         "-"
      //       )}
      //     </>
      //   ),
      // },
    ],
    []
  );
  const [inputText, setInputText] = useState("");

  // const filteredDataCoupon = tableData.filter((el) => {
  //
  //   return el.code.toLowerCase().includes(inputText);
  // });
  //

  // useEffect(() => {
  //   setPageNumbers([...Array(totalPages).keys()].map((i) => i + 1));
  // }, [totalPages]);

  // const handlePagination = async (pageNumber) => {
  //   setCurrentPage(pageNumber);
  // };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    rows,
    pageCount,
    prepareRow,
  } = useTable({ columns, data: tableData });

  const handleChange = (event, value) => {
    setCurrentPage(value);
  };

  const [gotoPageInput, setGotoPageInput] = useState();

  const handleGotoPage = () => {
    const pageNumber = parseInt(gotoPageInput, 10);
    if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber);
      setGotoPageInput("");
    }
  };

  console.log("currentPage", currentPage);
  return (
    <div className="table_wrapper">
      <div style={{ marginTop: "20px" }} className="table_scroll">
        <table {...getTableProps()} className="leaderboard-table">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()}>
                    {column.render("Header")}
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {/* {rows.map((row) => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map((cell) => (
                    <td
                      className={`${
                        cell.column.Header === "Status" ? "status_column" : ""
                      }`}
                      {...cell.getCellProps()}
                    >
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })} */}
            {rows?.map((row, rowIndex) => {
              prepareRow(row);
              return (
                <Fragment key={rowIndex}>
                  <tr
                    {...row.getRowProps()}
                    className={`economiccalender-row ${
                      selectedRow === rowIndex
                        ? "economiccalender-row-active"
                        : ""
                    } `}
                    onClick={() =>
                      selectedRow === rowIndex
                        ? setSelectedRow(null)
                        : setSelectedRow(rowIndex)
                    }
                  >
                    {row.cells.map((cell) => (
                      <td
                        className={`${
                          cell.column.Header === "Status" ? "status_column" : ""
                        }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                  </tr>
                  {selectedRow === rowIndex && (
                    <tr>
                      <td
                        colSpan="7"
                        className="row-selected"
                        style={{ width: "100%" }}
                      >
                        <div className="supportcases-td-container">
                          <div className="td-main-div">
                            <div className="header_main">
                              <h3 className="row-head">
                                {row.original.subject}
                              </h3>
                            </div>

                            <div className="supportcases-type-details">
                              {row?.original?.meta &&
                              Object.keys(row.original.meta).length > 0 ? (
                                <>
                                  {" "}
                                  {Object.keys(row?.original?.meta || {}).map(
                                    (key) => {
                                      const value = row?.original?.meta[key];

                                      const renderValue = (item, parentKey) => {
                                        if (
                                          typeof item === "object" &&
                                          item !== null
                                        ) {
                                          return (
                                            <div
                                              style={{
                                                marginLeft: "20px",
                                                marginBottom: "10px",
                                              }}
                                            >
                                              {Object.entries(item).map(
                                                ([subKey, subValue]) => (
                                                  <div
                                                    key={subKey}
                                                    style={{
                                                      marginBottom: "8px",
                                                      display: "flex",
                                                    }}
                                                  >
                                                    <span
                                                      style={{
                                                        textTransform:
                                                          "capitalize",
                                                        color: "#8b8e93",
                                                        display: "inline-block",
                                                        minWidth: "150px",
                                                      }}
                                                    >
                                                      {subKey.replace("_", " ")}
                                                      :
                                                    </span>
                                                    {renderValue(
                                                      subValue,
                                                      `${parentKey}.${subKey}`
                                                    )}
                                                  </div>
                                                )
                                              )}
                                            </div>
                                          );
                                        }

                                        return (
                                          <div
                                            style={{
                                              display: "flex",
                                              alignItems: "center",
                                              gap: "10px",
                                            }}
                                          >
                                            <span>{item || "NA"}</span>
                                            {item && (
                                              <CopyToClipboard
                                                text={item}
                                                onCopy={() =>
                                                  handleCopyToClipboard(item)
                                                }
                                              >
                                                <p
                                                  className="table_copy_button"
                                                  style={{
                                                    cursor: "pointer",
                                                    marginLeft: "10px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                  }}
                                                >
                                                  <svg
                                                    width="18"
                                                    height="18"
                                                    viewBox="0 0 24 24"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                  >
                                                    <rect
                                                      width="24"
                                                      height="24"
                                                      rx="12"
                                                      fill="#FFF"
                                                    />
                                                    <path
                                                      d="M17.886 12.574C18 12.2987 18 11.9487 18 11.25C18 10.5513 18 10.2013 17.886 9.926C17.8106 9.74395 17.7001 9.57854 17.5608 9.43922C17.4215 9.29989 17.256 9.18938 17.074 9.114C16.7987 9 16.4487 9 15.75 9H11.4C10.56 9 10.14 9 9.81933 9.16333C9.53684 9.30719 9.30719 9.53684 9.16333 9.81933C9 10.1393 9 10.5593 9 11.4V15.75C9 16.4487 9 16.7987 9.114 17.074C9.26667 17.4413 9.55867 17.734 9.926 17.886C10.2013 18 10.5513 18 11.25 18C11.9487 18 12.2987 18 12.574 17.886M17.886 12.574C17.8106 12.756 17.7001 12.9215 17.5608 13.0608C17.4215 13.2001 17.256 13.3106 17.074 13.386C16.7987 13.5 16.4487 13.5 15.75 13.5C15.0513 13.5 14.7013 13.5 14.426 13.614C14.244 13.6894 14.0785 13.7999 13.9392 13.9392C13.7999 14.0785 13.6894 14.244 13.614 14.426C13.5 14.7013 13.5 15.0513 13.5 15.75C13.5 16.4487 13.5 16.7987 13.386 17.074C13.3106 17.256 13.2001 17.4215 13.0608 17.5608C12.9215 17.7001 12.756 17.8106 12.574 17.886M17.886 12.574C17.5275 13.8107 16.8678 14.9391 15.9661 15.8582C15.0645 16.7774 13.9489 17.4585 12.7193 17.8407L12.574 17.886M15 9V8.4C15 7.56 15 7.14 14.8367 6.81933C14.693 6.53694 14.4636 6.3073 14.1813 6.16333C13.86 6 13.44 6 12.6 6H8.4C7.56 6 7.14 6 6.81933 6.16333C6.53684 6.30719 6.30719 6.53684 6.16333 6.81933C6 7.13933 6 7.55933 6 8.4V12.6C6 13.44 6 13.86 6.16333 14.1807C6.30733 14.4633 6.53667 14.6927 6.81933 14.8367C7.13933 15 7.56 15 8.40067 15H9"
                                                      stroke="#36D66B"
                                                      strokeLinecap="round"
                                                      strokeLinejoin="round"
                                                    />
                                                  </svg>
                                                </p>
                                              </CopyToClipboard>
                                            )}
                                          </div>
                                        );
                                      };

                                      return (
                                        <div
                                          key={key}
                                          className="supportcases-box"
                                        >
                                          <p
                                            style={{
                                              textTransform: "capitalize",
                                              fontWeight: "bold",
                                              fontSize: "16px",
                                              marginBottom: "10px",
                                            }}
                                          >
                                            {key.replace("_", " ")}
                                          </p>
                                          {renderValue(value, key)}
                                        </div>
                                      );
                                    }
                                  )}
                                </>
                              ) : (
                                "No meta data available"
                              )}
                            </div>
                          </div>
                          {/* add here expandable table */}
                          {row?.original?.payout_audit_logs &&
                          row.original.payout_audit_logs.length > 0 ? (
                            <div
                              className="payout-audit-logs"
                              style={{ marginTop: "20px", width: "100%" }}
                            >
                              <h4
                                style={{
                                  fontSize: "16px",
                                  fontWeight: "600",
                                  marginBottom: "10px",
                                  color: "#333",
                                }}
                              >
                                Payout Audit Logs
                              </h4>
                              <table
                                style={{
                                  width: "100%",
                                  borderCollapse: "collapse",
                                  background: "#fff",
                                  fontSize: "14px",
                                }}
                              >
                                <thead>
                                  <tr
                                    style={{ borderTop: "none" }}
                                    className="logs_header_tr"
                                  >
                                    <th>Field</th>
                                    <th>Old Value</th>
                                    <th>New Value</th>
                                    <th>Changed By</th>
                                    <th>IP Address</th>
                                    <th>Reason</th>
                                    <th>Changed At</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {row.original.payout_audit_logs.map(
                                    (log, index) => (
                                      <tr
                                        key={index}
                                        // style={{ borderTop: "none" }}
                                        className="logs_tr"
                                      >
                                        <td>
                                          {log.field_name?.replace("_", " ") ||
                                            "-"}
                                        </td>
                                        <td>
                                          {log.old_value?.replace("_", " ") ||
                                            "-"}
                                        </td>
                                        <td>{log.new_value || "-"}</td>
                                        <td>{log.changed_by || "-"}</td>
                                        <td>{log.ip_address || "-"}</td>

                                        <td className="reason-column">
                                          {log.change_reason || "-"}
                                        </td>
                                        <td>
                                          {log.changed_at
                                            ? new Date(
                                                log.changed_at
                                              ).toLocaleString()
                                            : "-"}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </tbody>
                              </table>
                            </div>
                          ) : (
                            <p style={{ marginTop: "10px", color: "#888" }}>
                              No logs found.
                            </p>
                          )}
                        </div>
                      </td>
                    </tr>
                  )}
                </Fragment>
              );
            })}
          </tbody>
        </table>{" "}
      </div>

      <div className="spacerT30p"></div>
      {rows?.length > 0 ? (
        <div
          className="pagination_wrapper"
          style={{ display: "flex", alignItems: "center", gap: "20px" }}
        >
          <Pagination
            onChange={handleChange}
            count={totalPages}
            variant="outlined"
            page={currentPage}
            color="primary"
          />
          <div className="goto-page-input">
            <input
              type="number"
              placeholder="Go to Page"
              value={gotoPageInput}
              onChange={(e) => setGotoPageInput(e.target.value)}
            />
            <button className="goToButton" onClick={handleGotoPage}>
              Go
            </button>
          </div>
        </div>
      ) : (
        <div
          style={{ display: "flex", width: "100%", justifyContent: "center" }}
        >
          No data
        </div>
      )}
    </div>
  );
};

const DeleteModal = ({
  isModalOpen,
  closeModal,
  deleteContent,
  onConfirmDelete,
  idToken,
}) => {
  const dispatch = useDispatch();
  const handleDelete = () => {
    dispatch(deleteCoupon({ idToken: idToken, code: deleteContent }));
    closeModal();
  };

  return (
    <div className="modal">
      <div className="modal_content">
        <p>Are you sure you want to delete?</p>
        <div className="modal_btn">
          <button onClick={handleDelete}>Yes</button>
          <button onClick={closeModal}>No</button>
        </div>
      </div>
    </div>
  );
};
